import { normalizeArray, without, emptyAction } from '../utils'

const push = (stack, elt) => [...stack, ...normalizeArray(elt)]

const pop = (stack, count = 1) => stack.slice(0, -(count))

const replace = (stack, elt) => push(pop(stack), elt)

/**
 * Basic "stack" reducer for arbitrary elements.
 * Works best with primitive types, since "REMOVE" functionality
 * will test for any element in stack that is strictly equal to the
 * desired element to remove.
 * For more advanced use-cases with arrays of objects tracked by
 * ID, see "collectionReducer".
 *
 * @alias module:stack
 * @param {Array} [defaultState=[]] initial state to return, null or error
 * @param {{}} [types] action types for stack actions
 * @param {string} types.push push action type
 * @param {string} types.pop pop action type
 * @param {string} types.replace replace action type
 * @param {string} types.remove remove action type
 * @param {string} types.clear clear action type
 * @return {function} redux reducer function
 */
const stackReducer = (
  defaultState = [],
  {
    push: pushAction,
    pop: popAction,
    replace: replaceAction,
    remove: removeAction,
    clear: clearAction
  } = {}
) => {
  return (stack = defaultState, { type, payload } = emptyAction()) => {
    switch (type) {
      case pushAction: {
        return push(stack, payload)
      }
      case popAction: {
        return pop(stack, payload)
      }
      case replaceAction: {
        return replace(stack, payload)
      }
      case removeAction: {
        return without(stack, ...normalizeArray(payload))
      }
      case clearAction: {
        return defaultState
      }
      default: return stack
    }
  }
}

export default stackReducer
